import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'prismjs/prism';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Provider } from 'react-redux';
import { enableES5 } from 'immer';
import * as serviceWorker from 'src/serviceWorker';
import store from 'src/store';
import App from 'src/App';

interface SentryConfig {
  dsn: string;
  environment?: string;
}

const {
  REACT_APP_SENTRY_DSN: sentryDSN,
  REACT_APP_SENTRY_ENV: sentryEnv,
} = process.env;

if (sentryDSN) {
  const sentryConf: SentryConfig = {
    dsn: sentryDSN,
  };

  if (sentryEnv) {
    sentryConf.environment = sentryEnv;
  }

  Sentry.init({
    ...sentryConf,
    integrations: [new Integrations.BrowserTracing() as any],
    tracesSampleRate: 1.0,
  });
}

enableES5();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.register();
